module.exports = __webpack_public_path__ + "static/media/error.918cc86.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/error.wav
// module id = ifRC
// module chunks = 176